import axios from "@/api/axios";
import qs from "qs";

const getList = async (params, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: 1,
    pagesize: 10,
    swinglistcnt: "0",
    swinglist: [],
  };
  const options = {
    method: "GET",
    url: "/swing/swinglist",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify(params)
    params: params,
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(false, response.data);
    }
  });
};

const getView = async (swingno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    pageno: 1,
    pagesize: 10,
    managerlistcnt: "0",
    managerlist: [],
  };
  const options = {
    method: "GET",
    url: "/swing/swingview/" + swingno,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify(params)
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(null);
    }
  });
};

const changeFlag = async (flag, swingno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "GET",
    url: "/app/swing/swingopen.php",
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify(params)
    params: { flag: flag, swingno: swingno },
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(null);
    }
  });
};
const deleteSwing = async (swingno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };
  const options = {
    method: "PUT",
    url: "/postact/swingdrop/" + swingno,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //data: qs.stringify(params)
  };

  await axios(options).then((response) => {
    if (response.data.code === 200) {
      finalData = response.data;
      result(true, finalData);
    } else {
      result(null);
    }
  });
};
const getSwingreplyList = async (swingno, pageno, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    pagesize: 10,
    swingreplylistcnt: 0,
    swingreplylist: [],
  };
  const options = {
    method: "GET",
    url: "/swing/swingreplylist/" + swingno,
    params: {
      pageno: pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_swingreplylist", err);
    result(false, err);
  }
};

// 스윙댓글등록 등록
const setSwingreplyWrite = async (swingno, nickname, text, result) => {
  const options = {
    method: "POST",
    url: "/swing/swingreplywrite/" + swingno,
    data: qs.stringify({
      nickname: nickname,
      text: text,
    }),
  };

  try {
    await axios(options).then((response) => {
      // console.log(response.data)
      if (response.data.code === 200) {
        result(true, response.data.message);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("setSwingreplyWrite", err);
    result(false, err);
  }
};

// 스윙댓글등록 삭제
const setSwingreplyDrop = async (swingno, replyno, result) => {

  const options = {
    method: "DELETE",
    url: "/postact/swingreplydrop/" + swingno + "/" + replyno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data.message);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("setSwingreplyDrop", err);
    result(false, err);
  }
};


const setSwingTitleWrite = async (swingno, title, content, flag, result) => {
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "POST",
    url: process.env.VUE_APP_API_URL + "/swing/swingtitlewrite/" + swingno,
    data: qs.stringify({
      title: title,
      content: content,
      flag: flag,
    }),
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_memberswingreplyanswerwrite", err);
    result(false, err);
  }
};
export default {
  getList,
  getView,
  changeFlag,
  deleteSwing,
  getSwingreplyList,
  setSwingreplyWrite,
  setSwingreplyDrop,
  setSwingTitleWrite,
};
